import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSundryCreditorBalanceApi } from "../../../apiservice/accounts";

export const fetchSupplierDue = createAsyncThunk(
  "supplierDue/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const reqPayload = {
        supplierId: filters.supplierId || null,
        fromDate: filters.fromDate || undefined,
        toDate: filters.toDate || undefined,
      };

      const res = await getSundryCreditorBalanceApi(reqPayload);
      
      if (res.data && res.data.accounts) {
        return res.data.accounts;
      }
      
      return [];
    } catch (err) {
      console.error("Error fetching supplier due data:", err);
      
      if (err.response?.status === 401) {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Authentication failed");
      }
      
      return rejectWithValue(
        err.response?.data?.message || 
        err.message || 
        "Failed to fetch supplier due data"
      );
    }
  }
);